import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import isEmpty from "lodash/isEmpty";

//CSS
import '../../../css/donation-form.css';

//Components
import NumberFormat from 'react-number-format';

// State
import { addDonationToCart } from '../../../store/actions/cart'

class DonationForm extends Component {
    constructor(props){
        super(props)
        this.state = {
            amount: "",
        }
    }

    handleInputChange(event){
		this.setState({
			[event.target.id]: event.target.value
		})
    }

    handleKeyPress(event){
		if(event.key === 'Enter'){
			this.handleSubmit(event)
		}
    }

    handleSubmit(event){
        event.preventDefault();
        this.props.addDonationToCart(this.state.amount, !isEmpty(this.props.donation) ? this.props.donation[0].id : null);
        this.setState({amount: ""});
    }

    render() {
        const { amount } = this.state;
        const { charity, error, success, loading } = this.props;
        return (
            <Fragment>
                <hr className="base-divider"/>
                {/* Title */}
                <Fragment>
                    <h2 className="review-form-titles">{!!charity && !isEmpty(charity.charity) ? charity.charity + ' Donation:' : 'Make A Donation:'}</h2>
                    {!!charity && charity.message ? <div className="charity-title">{charity.message}</div> : <Fragment></Fragment>}
                </Fragment>

                {/* Errors & Success*/}
                {!!error && Object.keys(error).map(errorKey => {
                    return <div className="error top-margin" key={errorKey}>{error[errorKey]}</div>
                })}
                {success && <div className="success top-margin">{success}</div>}

                {/* Form Field */}
                <div className="floated-field-container"> 
                    <div className="form-field half-field">
                        <NumberFormat id="amount" value={amount} prefix={'$'} decimalScale={2} fixedDecimalScale={true}
                            placeholder="Enter amount"
                            onKeyPress={e => this.handleKeyPress(e)}
                            onChange={e => this.handleInputChange(e)}
                            disabled={loading}
                        />
                    </div>
                    <div className="form-field half-field">
                        <button className={"btn btn--floated-right" + (loading ? ' loading' : '')} disabled={loading} onClick={e => this.handleSubmit(e)}><span>Apply Donation</span></button>
                    </div>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        donation: state.cart.donation,
        error: state.cart.donationError,
        success: state.cart.donationSuccess,
        loading: state.cart.donationLoading
    }
}

export default connect(mapStateToProps, { addDonationToCart })(DonationForm)



// WEBPACK FOOTER //
// ./src/components/checkout/order-review/DonationForm.js